export default "__VITE_ASSET__f40a0ace__"